import $ from 'jquery';

export default function (params) {
  //'designation',
  var fields = [
    'location_name',
    'location_street',
    'location_address_add',
    'location_zip',
    'location_city',
    'location_country_code',
  ];

  function toggleLocationFields() {
    var locationCheck = $(this);
    var isShown = locationCheck.is(':checked');

    $.each(fields, function (index, fieldname) {
      var field = $('[name="' + fieldname + '"]');
      var parent = field.parents('.form-group').first();

      if (isShown) {
        parent.show('slow');
      } else {
        parent.hide('slow');
      }
    });
  }

  $('#location_is_different').on('change', toggleLocationFields)

  toggleLocationFields.call($('#location_is_different'));

}
